export const isUrl = (string) => {
  try {
    const _ = new URL(string);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
